import React, { createContext, useContext, useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { detectUserCountry } from '../services/geolocationService';

const StripeContext = createContext();

const stripePromise = loadStripe(import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeProvider = ({ children }) => {
  const [userLocation, setUserLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const detectLocation = async () => {
      try {
        const location = await detectUserCountry();
        setUserLocation(location);
      } catch (error) {
        console.error('Failed to detect user location:', error);
        // Fallback to Brazil
        setUserLocation({
          country: 'BR',
          countryName: 'Brazil',
          language: 'pt-BR',
          currency: 'BRL'
        });
      } finally {
        setLoading(false);
      }
    };

    detectLocation();
  }, []);

  const stripeOptions = {
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#3b82f6',
        colorBackground: '#ffffff',
        colorText: '#1f2937',
        colorDanger: '#ef4444',
        fontFamily: 'Inter, system-ui, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      }
    },
    locale: userLocation?.language?.split('-')?.[0] || 'pt'
  };

  return (
    <StripeContext.Provider value={{ 
      stripePromise, 
      stripeOptions, 
      userLocation,
      loading 
    }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};

export default StripeContext;